import { useSetupFlowStep } from 'accounts/hooks/homeowners/use-setup-flow-step-context';
import { HomeLicensesDC } from './dc/home-licenses-dc';
import { HomeLicensesMI } from './mi/home-licenses-mi';

/**
 * The "Licenses" step is one flow step shared by every market that has a licenses payload, so the
 * market variant is chosen here from the envelope's `state` discriminator rather than by the router.
 *
 * The step is only generated for markets the backend implements, so an unsupported `state` means the
 * two have drifted — say a market was enabled server-side before its form landed here. Saying so is
 * better than rendering another market's questions, which is what happened before this dispatcher
 * existed: a Michigan home was shown the DC form, asking for a RAD registration that does not exist
 * outside DC.
 */
export function HomeLicenses() {
  const { currentStepFormData } = useSetupFlowStep()!;

  const state = currentStepFormData?.state;

  // The route mounts this component before the step's data resolves — the layout renders its spinner
  // alongside the step, not in place of it — so `state` is undefined on the first paint. Rendering
  // nothing until it arrives keeps the unsupported-market notice from flashing on every load, and
  // means each variant mounts with its real `initialValues` instead of empty ones.
  if (!state) return null;

  if (state === 'DC') return <HomeLicensesDC />;
  if (state === 'MI') return <HomeLicensesMI />;

  return (
    <div className="mt-xl rounded border border-solid border-gray bg-light-gray p-lg text-body text-navy">
      {`We don't have licensing questions for ${state} yet. Please continue — we'll reach out if we need anything for this home.`}
    </div>
  );
}
